import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
const wrapperIsDisabledCss = "w1v7uual";
const wrapperCss = "w1ebfaou";
const Wrapper = forwardRef((props, ref) => {
  const {
    isDisabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsDisabledCss]: isDisabled
  }, props.className)} />;
});
const ConferenceErrorMessage = ({
  kind,
  organizerName,
  config
}) => {
  const {
    conferenceName,
    link
  } = config[kind];
  const LinkComponent = useCallback(({
    children
  }) => <Link href={link} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>, [link]);
  return HtmlParser(I18n.t('publisher.event_type_editor.sections.event_details.fields.location.integration_error', {
    name: organizerName,
    integration_service: conferenceName
  }), {
    LinkComponent
  });
};
export const OrganizerIntegrationError = ({
  kind,
  organizerName,
  ...props
}) => {
  const config = {
    zoom_conference: {
      conferenceName: 'Zoom',
      link: '/integrations/zoom'
    },
    gotomeeting_conference: {
      conferenceName: 'GoTo Meeting',
      link: '/integrations/gotomeeting'
    },
    microsoft_teams_conference: {
      conferenceName: 'Microsoft Teams',
      link: '/integrations/microsoft_teams'
    },
    webex_conference: {
      conferenceName: 'Webex',
      link: '/integrations/webex'
    },
    google_conference: {
      conferenceName: 'Google',
      link: '/app/availability/connected_calendars'
    }
  };
  return <Wrapper {...props}>
      <ConferenceErrorMessage kind={kind} organizerName={organizerName} config={config} />
    </Wrapper>;
};

require("./integration_error.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./integration_error.js");